import { useEffect } from 'react'

import { Header } from '@/components'
import { BridgeService } from '@/services'
import { scrollTop } from '@/utils/redirect'

import * as S from './styles'

const SKELETON_HEIGHT_MAP: Record<string, string> = {
  menu_item_carousel_skeleton: '120px',
  list_item_skeleton: '98px',
  carousel_list_item_skeleton: '94px',
  carousel_banner_skeleton: '197px',
  section_header_skeleton: '24px',
  score_improvement_cards_skeleton: '187px',
  list_skeleton: '98px',
  grid_skeleton: '140px',
  accordion_skeleton: '160px',
  accordion_classification_skeleton: '160px',
  double_list_view_skeleton: '60px',
  list_cards_skeleton: '120px',
  list_buttons_skeleton: '48px',
  feedback_skeleton: '200px',
}

interface HomeShimmerProps {
  skeleton?: Skeleton
}

const DefaultSkeleton = () => (
  <>
    <S.ShimmerContainer>
      <S.SkeletonBox height="120px" style={{ marginTop: '24px' }} />
    </S.ShimmerContainer>
    <S.ShimmerContainer>
      <S.SkeletonBox height="98px" style={{ marginTop: '24px' }} />
    </S.ShimmerContainer>
    <S.ShimmerContainer>
      <S.SkeletonBox height="94px" style={{ marginTop: '24px' }} />
    </S.ShimmerContainer>
    <S.ShimmerContainer>
      <S.SkeletonBox height="197px" style={{ marginTop: '24px' }} />
    </S.ShimmerContainer>
    <S.ShimmerContainer>
      <S.SkeletonBox height="24px" style={{ marginTop: '24px' }} />
    </S.ShimmerContainer>
    <S.ShimmerContainer>
      <S.SkeletonBox height="187px" style={{ marginTop: '24px' }} />
    </S.ShimmerContainer>
  </>
)

const getSkeletonKey = (component: SkeletonComponent, position: number) =>
  `${component.type}-${component.style?.marginTop ?? 'default'}-${position}`

const DynamicSkeleton = ({ skeleton }: { skeleton: Skeleton }) => (
  <>
    {skeleton.components.map((component, position) => {
      const height = SKELETON_HEIGHT_MAP[component.type] ?? '80px'
      return (
        <S.ShimmerContainer key={getSkeletonKey(component, position)}>
          <S.SkeletonBox
            height={height}
            style={{
              marginTop: component.style?.marginTop ?? '24px',
              marginBottom: component.style?.marginBottom,
            }}
          />
        </S.ShimmerContainer>
      )
    })}
  </>
)

export const HomeShimmer = ({ skeleton }: HomeShimmerProps) => {
  useEffect(() => {
    scrollTop()
  }, [])
  return (
    <>
      <Header onBackClick={() => BridgeService.navigateHome()} />
      <S.Container>
        {skeleton ? <DynamicSkeleton skeleton={skeleton} /> : <DefaultSkeleton />}
      </S.Container>
    </>
  )
}

export default HomeShimmer
